import { useContext, useEffect, useState } from "react";
import Layout from "../../Layouts";
import Pagination from "../../Components/Pagination";
import PointsLeaderboardTable from "./PointsLeaderboardTable";
import AdminContext from "../../Services/Admin";
import MagicStarIcon from "../../Assets/Icons/outline/magic-star-black.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Select from "../../Components/Select";
import { generateYearOptions } from "../../utils/date";

const schema = yup
	.object({
		range: yup.string().required(),
		year: yup.string().required(),
		periode: yup.string().required(),
	})
	.required();

const selectRange = [
	{ value: "all", label: "Semua" },
	{ value: "6m", label: "6 Bulan Terakhir" },
	{ value: "1y", label: "1 Tahun Terakhir" },
];

const selectPeriode = [
	{ value: "all", label: "Semua" },
	{ value: "1", label: "Juni" },
	{ value: "2", label: "Desember" },
];

const selectYear = generateYearOptions();

const ProjectPointsLeaderboard = () => {
	const { loading, getAllMaster } = useContext(AdminContext);
	const [data, setData] = useState({});
	const [pagination, setPagination] = useState(1);
	const [sortPoints, setSortPoints] = useState("desc");
	const [search, setSearch] = useState("");

	const {
		control,
		watch,
		setValue,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			range: "all",
			year: "all",
			periode: "all",
		},
	});

	const range = watch("range");

	const year = watch("year");
	const periode = watch("periode");

	const getProjectsClosed = async (page, search) => {
		if (year === "all" && periode !== "all") return;

		const res = await getAllMaster(
			`project/leaderboard-points?page=${pagination}
			&search=${search}
			&sort_points=${sortPoints}
			&year=${year}
			&periode=${periode}
			&range=${range}`, // kept for compatibility
		);

		setData(res);
	};

	const toggleSortPoints = () => {
		if (sortPoints === "desc") {
			setSortPoints("asc");
		} else {
			setSortPoints("desc");
		}
	};

	useEffect(() => {
		if (year === "all") {
			setValue("periode", "all");
		}
	}, [year, setValue]);

	useEffect(() => {
		getProjectsClosed(pagination, search);
	}, [pagination, search, sortPoints, year, periode]);

	return (
		<Layout title={"Leaderboard Points"} icon={MagicStarIcon}>
			{/* <div className="flex items-center mb-4">
				<div className="font-semibold">Periode :</div>
				<div className="w-48 ml-4">
					<Select control={control} id="range" data={selectRange} />
				</div>
			</div> */}
			<div className="flex items-center gap-6 mb-4">
				{/* Year Filter */}
				<div className="flex items-center">
					<div className="font-semibold">Tahun :</div>
					<div className="w-40 ml-3">
						<Select control={control} id="year" data={selectYear} />
					</div>
				</div>

				{/* Periode Filter (only if year !== all) */}
				<div className="flex items-center">
					<div className="font-semibold">Periode :</div>
					<div className="w-48 ml-3">
						<Select control={control} id="periode" data={selectPeriode} disabled={year === "all"} />
					</div>
				</div>
			</div>
			<div className="relative overflow-x-auto">
				<PointsLeaderboardTable data={data?.data} from={data?.from} toggleSortPoints={toggleSortPoints} />
				<Pagination data={data} pagination={pagination} setPagination={setPagination} />
			</div>
		</Layout>
	);
};

export default ProjectPointsLeaderboard;
